<template>
	<div>
		<case-form :schema="schema" />
	</div>
</template>

<script>
import CaseForm from "../../CaseForm/CaseForm.vue"

export default {
	name: "CBProposalReferences",
	components: { CaseForm },
	data() {
		return {
			schema: [
				{
					label:
						"21. Unless proposing for renewal, give two references FROM YOUR TRADE:",
					component: "longText",
					bindTo: "case.facts.tradeReferences"
				}
			]
		}
	}
}
</script>
